export default __webpack_public_path__ + "static/media/daily.06532139.svg";